import React from "react";
import { useDictionary } from "@adamlip/okeoke.client";

function SubmittedOrderInvoiceDetails(props) {
  const { invoiceInfo, invoices, invoiceNeeded } = props;

  const { getValue } = useDictionary();

  return (
    <div className="submitted-order-details-blocks-root">
      {invoiceNeeded === 1 && (
        <>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_address_name")}:
            </div>
            <div className="submitted-order-block-data">
              {invoiceInfo?.name}
            </div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_address_zip")}:
            </div>
            <div className="submitted-order-block-data">{invoiceInfo?.zip}</div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_address_state")}:
            </div>
            <div className="submitted-order-block-data">
              {invoiceInfo?.state}
            </div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_address_city")}:
            </div>
            <div className="submitted-order-block-data">
              {invoiceInfo?.city}
            </div>
          </div>
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_address_street")}:
            </div>
            <div className="submitted-order-block-data">
              {`${invoiceInfo?.street} ${invoiceInfo?.streetNumber}`}
            </div>
          </div>
        </>
      )}
      {invoices.map((invoice) => (
        <div key={invoice.extID} className="submitted-order-block">
          <div className="submitted-order-block-label">
            {invoice.vatInvoice
              ? getValue("app_v2_invoiceID")
              : getValue("app_v2_receiptID")}
            :
          </div>
          <div className="submitted-order-block-data">
            <span className="invoice-extID">{invoice.extID}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SubmittedOrderInvoiceDetails;
